<template>
  <div>
    <div class="social-buttons">
      <div>
        <!-- <p class="social-buttons__login-with">Log in with:</p> -->
        <p class="social-buttons__login-with">{{ socialLabel }}</p>
      </div>
      <!-- <div class="social-buttons__single">
        <a :href="url.facebook" class="cp"> -->
          <!-- <font-awesome-icon
                size="2x"
                :icon="['fab', 'facebook-f']"
          /> -->
          <!-- <i class="fab fa-2x fa-facebook-f" aria-hidden="true"></i> -->
          <!-- <img src="../../assets/images/fb-icon.png" alt="" />
        </a>
      </div> -->
      <div class="social-buttons__single social-buttons__middle-button">
        <a :href="url.google" class="cp">
          <!-- <font-awesome-icon
                size="2x"
                :icon="['fab', 'google']"
          /> -->
          <!-- <i class="fab fa-2x fa-google" aria-hidden="true"></i> -->
          <img src="../../assets/images/google-icon.png" alt="" />
        </a>
      </div>
      <div class="social-buttons__single">
        <a :href="url.linkedin" class="cp">
          <!-- <font-awesome-icon
                size="2x"
                :icon="['fab', 'linkedin']"
          /> -->
          <!-- <i class="fab fa-2x fa-linkedin"></i> -->
          <img src="../../assets/images/linkedin-icon.png" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { SOCIAL_LOGIN_URLS } from "./utils/constants";
import { onMounted } from "vue";
export default {
  name: "social-login",
  data: function () {
    return {
      url: SOCIAL_LOGIN_URLS,
    };
  },
  props: {
    socialLabel: String,
  },
};
</script>

<style lang="scss" scoped>
.social-buttons {
  display: flex;
  // justify-content: center;
  align-items: center;
  margin-top: 20px;
  // margin: 1rem 0 2rem 0;
  gap: 0;
  &__login-with {
    color: #647490;
    font-weight: 700;
    font-size: 16px;
    margin: 0 20px 0 0px;
    @media screen and (max-width: 600px) {
      margin: 0;
    }
  }
  &__single {
    height: 35px;
    width: 150px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white !important;
    font-size: 12px;
    padding: 20px 60px;
    // cursor: pointer;

    @media screen and (max-width: 600px) {
      // width: 200px;
      width: 100%;
    }
    a {
      color: white !important;
    }
  }
  &__middle-button {
    margin: 0 12px;
  }
  &__facebook {
    background-color: #475791;
  }
  &__linkedin {
    background-color: #0075b4;
  }
  &__google {
    background-color: #de483c;
  }
  @media screen and (max-width: 600px) {
    flex-direction: column;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/social-login.vue